// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Chyl","questions":"styles_questions__171RT","footer":"styles_footer__30kHO"};